import * as React from "react";

const IconZoomPermissionError = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="322"
    height="230"
    fill="none"
    viewBox="0 0 322 230"
  >
    <path
      fill="#F3F7FF"
      d="M175.167 82.242c4.979 0 9.016 4.028 9.016 8.995 0 4.968-4.037 8.995-9.016 8.995h82.432c4.979 0 9.015 4.029 9.015 8.997 0 4.967-4.036 8.995-9.015 8.995h28.336c4.979 0 9.015 4.027 9.015 8.995s-4.036 8.995-9.015 8.995h-24.472c-4.979 0-9.016 4.027-9.017 8.995s4.037 8.996 9.017 8.996h7.727c4.98 0 9.016 4.027 9.016 8.995s-4.036 8.995-9.016 8.995h-66.975q-.997-.001-1.933-.207a9 9 0 0 1-1.931.207H81.143c-4.98 0-9.016-4.027-9.016-8.995s4.036-8.995 9.016-8.995H30.91c-4.98 0-9.015-4.028-9.015-8.996s4.036-8.995 9.015-8.995h51.52c4.98 0 9.016-4.027 9.016-8.995s-4.036-8.995-9.015-8.995h-32.2c-4.98 0-9.016-4.028-9.016-8.995 0-4.968 4.036-8.997 9.015-8.997h51.521c-4.98 0-9.017-4.027-9.017-8.995s4.038-8.995 9.017-8.995zm115.92 71.963c4.979 0 9.016 4.027 9.016 8.995-.001 4.968-4.037 8.995-9.016 8.995s-9.017-4.027-9.017-8.995 4.038-8.995 9.017-8.995"
    ></path>
    <path
      fill="#1976D2"
      d="M104.933 189.59q-5.1 0-8.517-3.412T93 177.673v-94.19q0-5.093 3.416-8.505t8.517-3.412h13.066V55.111h7.955v16.455h52.843V55.111h7.386v16.455h13.067q5.1 0 8.516 3.412t3.417 8.505v41.989h-7.387v-12.483h-103.41v64.684q0 1.704 1.42 3.122 1.42 1.419 3.127 1.418h49.289v7.377zm-4.547-83.979h103.41V83.483q0-1.704-1.42-3.122t-3.126-1.418h-94.317q-1.707 0-3.127 1.418t-1.42 3.122z"
    ></path>
    <path
      fill="#1976D2"
      stroke="#1976D2"
      strokeWidth="0.5"
      d="M193.481 129.254q7.537 0 14.174 2.861 6.63 2.86 11.538 7.766 4.907 4.906 7.769 11.533 2.863 6.634 2.863 14.169t-2.862 14.174q-2.859 6.63-7.765 11.538t-11.533 7.768q-6.634 2.864-14.17 2.864t-14.174-2.863q-6.63-2.859-11.538-7.764-4.907-4.907-7.768-11.533-2.863-6.635-2.863-14.17 0-7.537 2.862-14.174 2.86-6.63 7.765-11.538 4.907-4.907 11.533-7.769 6.635-2.863 14.169-2.862Zm.007 6.198c-8.418 0-15.54 2.918-21.38 8.758s-8.757 12.961-8.757 21.38 2.918 15.54 8.757 21.38c5.84 5.84 12.962 8.758 21.38 8.759 8.419 0 15.54-2.919 21.38-8.759s8.759-12.962 8.759-21.38c0-8.419-2.919-15.54-8.759-21.38s-12.961-8.758-21.38-8.758Z"
    ></path>
    <path
      fill="#1976D2"
      stroke="#1976D2"
      strokeWidth="0.5"
      d="m204.592 181.412-26.948-26.948 4.383-4.383 26.948 26.948z"
    ></path>
    <path
      fill="#1976D2"
      stroke="#1976D2"
      strokeWidth="0.5"
      d="m204.592 149.646-26.948 26.949 4.383 4.382 26.948-26.948z"
    ></path>
  </svg>
);

export default IconZoomPermissionError;
